// extracted by mini-css-extract-plugin
module.exports = {"trust-card__thumbnail":"TrustCard_trust-card__thumbnail__3Xkvy","trust-card":"TrustCard_trust-card__5TneG","trust-card__body":"TrustCard_trust-card__body__2X8BT"};